import {
  Label as HeadlessLabel,
  type LabelProps as HeadlessLabelProps,
} from "@headlessui/react";
import { type ElementType } from "react";

import { cn } from "@/lib/utils";

export type LabelProps<T extends ElementType = "label"> = {
  required?: boolean;
  bold?: boolean;
} & HeadlessLabelProps<T>;

export default function Label<TTag extends ElementType = "label">({
  required,
  bold,
  ...props
}: LabelProps<TTag>) {
  return (
    <div className="flex items-center">
      <HeadlessLabel
        className={cn(
          "text-sm leading-5",
          bold ? "font-semibold text-gray-900" : "font-medium text-gray-700",
        )}
        {...(props as any)}
      />
      {required != null && (
        <span
          className={cn(
            "text-primary-500 text-sm leading-5",
            !required && "invisible",
          )}
        >
          *
        </span>
      )}
    </div>
  );
}
